'use client';

import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import styles from './iconButton.module.scss';

export type IconButtonSize = 'sm' | 'md' | 'lg';
export type IconButtonVariant = 'default' | 'ghost' | 'subtle';

export type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: ReactNode;
  size?: IconButtonSize;
  variant?: IconButtonVariant;
  'aria-label': string;
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton(
    { icon, size = 'md', variant = 'default', className, ...rest },
    ref
  ) {
    const sizeClass = styles[size];
    const variantClass = styles[variant];
    const mergedClassName = [
      styles.iconButton,
      sizeClass,
      variantClass,
      className
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <button ref={ref} type="button" className={mergedClassName} {...rest}>
        {icon}
      </button>
    );
  }
);
